import { Deserializable } from '../../protocols/deserializable';
import { MediaManagerAssetFolderDto } from './media-manager-asset-folder-dto';
import { MediaManagerFolderDto } from './media-manager-folder-dto';

export class MediaManagerAssetFolderUpdateEventDto implements Deserializable {
  public folder: MediaManagerAssetFolderDto;
  public deletedFolder: MediaManagerFolderDto | null;

  // Expected go model:
  // https://github.com/mobilefirstdev/budsense-image-service/blob/dev/models/AssetFolderUpdateEvent.go
  public onDeserialize() {
    this.folder = window?.injector?.Deserialize?.instanceOf(MediaManagerAssetFolderDto, this.folder);
    this.deletedFolder = this.deletedFolder
      ? window?.injector?.Deserialize?.instanceOf(MediaManagerFolderDto, this.deletedFolder)
      : null;
  }
}
